module.exports = __webpack_public_path__ + "static/media/abm.1edb8a72.png";